import './sass/style.scss';
import './js/app.js';

import './fonts/stylesheet.css';

import * as components0 from '../views/components/footer-slider/footer-slider.js'; import * as components1 from '../views/components/menu/horizontal/horizontal.js'; import * as components2 from '../views/components/project-gallery/project-gallery.js'; import * as components3 from '../views/components/searchform/index.js'; import * as components4 from '../views/components/slider/basic/index.js'; let components = [components0, components1, components2, components3, components4];
import * as blocks0 from '../views/blocks/ProductsSlider/index.js'; let blocks = [blocks0];
;
